import { ApolloError, useQuery } from "@apollo/client";
import { gql } from "../__generated__";
import { GetMyProfileQuery } from "../__generated__/graphql";

const GET_MY_PROFILE = gql(`
	query GetMyProfile {
		myProInformation {
			id
			userId
			firstName
			lastName
			email
			jobTitle
			tags {
				id
				name
				group
			}
			customTags {
				id
				name
			}
			yearsOfExperience
			phoneNumber
			phoneNumberVerified
			categoryIds
			onboardedAt
			tracks
			trades {
				id
				name
				levels {
				  certificate {
					  id
					}
				}
			}
			identityVerification(showDeclined: true) {
				id
				status
				identificationNumber
				type
				issues {
					code
					message
				}
			}
			associatedLaborHackEmail
			proApplication {
				country
				category {
					id
					proTitle
				}
				dateOfBirth
				gender
				incomeCurrency
				averageMonthlyIncome
				employmentStatus
				numberOfDaysWorkedPerWeek
				phoneType
				leadSource
				leadSourceText
				reasonForJoiningLaborHack
				reasonsForJoiningLaborHack
				reasonForJoiningLaborHackOtherText
				detailedAddress {
					address
					formattedAddress
					state
					city
					placeId
				}
			}
			overview
		}
	}
`);

export const useProfile = (): {
	loading: boolean;
	error?: ApolloError;
	profile?: GetMyProfileQuery["myProInformation"];
} => {
	const { loading, error, data } = useQuery(GET_MY_PROFILE);

	if (error && error.message.includes("Pro not found")) {
		return {
			loading: false,
		};
	}

	return {
		loading,
		error,
		...(!!data?.myProInformation && { profile: data.myProInformation }),
	};
};
